// "No recent GPS ping" idle detection. NOT movement detection — we have no
// location-history endpoint. A clocked-in worker is idle when their last ping
// is >= 60 minutes old. Missing/unparseable pingAt => unknown (not idle).
export const IDLE_MINUTES = 60;

export function idleInfo(pingAt) {
  if (!pingAt) return { isIdle: false, idleMinutes: null };
  const ts = Date.parse(pingAt);
  if (Number.isNaN(ts)) return { isIdle: false, idleMinutes: null };
  const idleMinutes = Math.floor((Date.now() - ts) / 60000);
  return { isIdle: idleMinutes >= IDLE_MINUTES, idleMinutes };
}
